export const STATUS_CONFIG = {
  active: {
    label: "Actif",
    className: "bg-[#A7C9A4]/25 text-[#1C2D1A] border border-[#A7C9A4]",
  },
  qualified: {
    label: "Qualifié",
    className: "bg-primary/15 text-primary border border-primary/30",
  },
  human_takeover: {
    label: "Humain",
    className: "bg-[#93C5FD]/30 text-[#1E3A8A] border border-[#93C5FD]/50",
  },
};

export const StatusBadge = ({ status, testId }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.active;
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${config.className}`}
    >
      {config.label}
    </span>
  );
};
